var React = require('react');

function Sneakers (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.6665 22V19.2105C1.6665 18.3641 2.19303 17.5973 2.97603 17.2895C3.70949 17.0087 4.39193 16.6038 5.01888 16.1316C5.72901 15.5967 6.3396 14.9254 6.84699 14.1805L8.6665 16L9.6665 15L7.58055 12.914C7.80805 12.4489 8.00056 11.9705 8.15735 11.4908L10.6665 14L11.6665 13L8.55012 9.88362C8.62746 9.4052 8.6665 8.93969 8.6665 8.5L10.1665 7.5L11.6665 9L14.1665 6.5L14.1665 3.5L15.6665 2L23.6665 10L19.6665 14H17.6665L16.6665 15L16.1665 17.5L11.6665 22H1.6665Z","fill":"#FFA057"}));
}

Sneakers.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = Sneakers;

Sneakers.default = Sneakers;
